import React, { Fragment } from "react";
import ReactECharts from "echarts-for-react";
import { useNavigate } from "react-router-dom";
import styles from "Components/Dashboard/dashboard.module.scss";
import { Spin } from "antd";
import { setFilter } from "Components/Topology/Device/deviceTableSlice";
import { getOption, ChartClick } from "Components/Dashboard/Components/utils";
import { useStatistic } from "Components/Dashboard/queries";
import { useAppSelector, useAppDispatch } from "store/hook";
import { Label, ChartContainer, DashCard } from "./Shared";
import { titleCase } from "Components/Topology/Device/utils";

// 預設 Signal(訊號)的預設值，當無法獲取數據時使用

const defaultStatistic = { sim: { Excellent: 0, Good: 0, Fair: 0, Poor: 0, NA: 0 } };

const PieStrength = React.memo(() => {
  const { loginCid, stateCid, level, isLogin } = useAppSelector((state) => state.global);
  const {
    data: deviceStatistic = defaultStatistic,
    isLoading,
    isFetching,
  } = useStatistic(level, stateCid, loginCid, isLogin);
  const sim = deviceStatistic.sim || [];
  // reduce() 方法將一個累加器及陣列中每項元素（由左至右）傳入回呼函式，將陣列化為單一值。
  // Object.values(sim) 將 sim 物件中的所有 value 提取成陣列。
  // number = Object.values(sim);   number = [ 0 , 0 , 1 , 0 , 18];
  // 將 sim 物件的 value 依序加總起來 = SignalSum
  const SignalSum = Object.values(sim).reduce((a, b) => a + b, 0);
  const loading = isLoading || isFetching;
  const disp = useAppDispatch();
  const navigate = useNavigate();

  // 點擊跳轉事件 將 點擊的參數傳入 setFilter.strength 跳轉至 ./overview
  const onChartClick = (params: ChartClick, label: string) => {
    const selected = params?.data?.name?.toLowerCase();
    disp(setFilter({ strength: [selected ?? label] }));
    navigate("./overview");
  };
  const onEvents = {
    click: onChartClick,
  };

  return (
    // 卡片標題
    <DashCard title={"DevicesStrength"}>
      {/* 當 Query(請求資料) isLoading 或者 isFetching 時候 顯示 Spin (加載動畫)*/}
      {loading ? (
        <Fragment>
          {/* <Label devicestatic={Object.entries(defaultStatistic.sim)} onChartClick={onChartClick} /> */}
          <Spin className={styles.loadingSpin} />
        </Fragment>
      ) : (
        <Fragment>
          <Label
            //Object.entries(sim) 將 sim 物件內容改變為 [key,value] 並用 titleCase(key) 依序檢查 key
            devicestatic={Object.entries(sim).map(([key, value]) => [titleCase(key), value])}
            onChartClick={onChartClick}
            tooltip={["ISMS.EXCELLENT", "ISMS.Good", "ISMS.Fair", "ISMS.Poor", "NA"]}
          />
          {/* 數據設備訊號總數不為 0 則 顯示圖表 */}
          {SignalSum !== 0 && (
            <ChartContainer sum={SignalSum}>
              <ReactECharts
                className={styles.pie__chart}
                option={getOption(Object.entries(sim))}
                notMerge={true}
                lazyUpdate={true}
                theme={"theme_name"}
                onEvents={onEvents}
              />
            </ChartContainer>
          )}
        </Fragment>
      )}
    </DashCard>
  );
});

export default PieStrength;
